import React, { forwardRef } from "react";
import { PropTypes } from "prop-types";
import { useTheme, MenuItem } from "@material-ui/core";
import { FilledSelect } from "../FilledSelect";
import ClearItem from "./ClearItem";
import SelectedDisplayValue from "./SelectedDisplayValue";

const GeofencePackageItem = forwardRef((props, ref) => {
  const { pkg, fleetDefault } = props;
  const theme = useTheme();

  if (!pkg) return null;

  const propsToPass = Object.keys(props).reduce((final, current) => {
    if (current !== "pkg" && current !== "fleetDefault") {
      final[current] = props[current];
    }
    return final;
  }, {});

  return (
    <MenuItem value={pkg?.id} component="div" ref={ref} {...propsToPass}>
      <ul style={{ listStyle: "none", paddingInlineStart: "0px" }}>
        <li>
          <SelectedDisplayValue
            showAsterisk={fleetDefault && pkg && fleetDefault === pkg?.url}
            text={pkg?.version}
          />
          <ul style={{ listStyle: "none", paddingInlineStart: theme.spacing(2) }}>
            <li>{`MAP: ${pkg?.map_id}`}</li>
            <li>{`RULES: ${pkg?.rules_id}`}</li>
          </ul>
        </li>
      </ul>
    </MenuItem>
  );
});

GeofencePackageItem.propTypes = {
  pkg: PropTypes.shape({
    id: PropTypes.string,
    version: PropTypes.string,
    map_id: PropTypes.string,
    rules_id: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  fleetDefault: PropTypes.string,
};

GeofencePackageItem.defaultProps = {
  fleetDefault: null,
};

const GeofencePackageSelect = (props) => {
  const { fleetDefault, geofencePackages } = props;

  const value = geofencePackages && geofencePackages.length ? props.value : "";

  return (
    <FilledSelect {...props} value={value}>
      {[
        <ClearItem key="clear" value="" />,
        ...geofencePackages.map((pkg) => (
          <GeofencePackageItem pkg={pkg} fleetDefault={fleetDefault} key={pkg?.id} value={pkg?.url}>
            <SelectedDisplayValue
              showAsterisk={fleetDefault && pkg && fleetDefault === pkg?.url}
              text={pkg?.version}
            />
          </GeofencePackageItem>
        )),
      ]}
    </FilledSelect>
  );
};

GeofencePackageSelect.propTypes = {
  fleetDefault: PropTypes.string,
  geofencePackages: PropTypes.array.isRequired,
  value: FilledSelect.propTypes.value,
};

GeofencePackageSelect.defaultProps = {
  fleetDefault: null,
  value: FilledSelect.defaultProps.value,
};

export default GeofencePackageSelect;
